import { gql } from '@apollo/client'

export const SABRE_GET_COMMON_NAMES = gql`
  query CommonNames($input: CommonNameInput) {
    commonNames(input: $input) {
      hasMore
      count
      results {
        name
        id
      }
    }
  }
`
